import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import { Country } from '@/shared/components';
import { Option } from '@/shared/uikitV2/Select/types';

import { StyledSelectV2 } from './styled';

const COUNTRY_FIELDS = [
  'country',
  'assignedCountry',
  'countryOfAcquisition',
  'countryOfOrigin',
  'selectedCountry',
  'citizenship',
  'countryOfBirth',
];

type SelectFromListProps<TFieldValues extends FieldValues> = {
  control: Control<TFieldValues, unknown>;
  name: Path<TFieldValues>;
  options?: Option[];
  label: string;
  required?: boolean | string;
  disabled?: boolean;
  isMultiple?: boolean;
  withSearch?: boolean;
};

export const SelectFromList = <TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  options,
  label,
  required,
  disabled,
  isMultiple,
  withSearch,
}: SelectFromListProps<TFieldValues>) => {
  if (!options) return null;

  const isCountryField = COUNTRY_FIELDS.includes(name as string);
  const selectOptions = isCountryField
    ? options.map((o, i) => ({
        ...o,
        content: {
          ...o.content,
          description: <Country key={i} icon code={String(o.value)} />,
        },
      }))
    : options;

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field, fieldState }) => {
        return (
          <StyledSelectV2
            multiple={Boolean(isMultiple)}
            name={field.name}
            onChange={field.onChange}
            status={fieldState.error ? 'error' : 'default'}
            errorText={fieldState.error?.message}
            options={selectOptions}
            label={label}
            required={Boolean(required)}
            iconAfter={isCountryField && field.value ? <Country code={field.value} icon /> : null}
            disabled={disabled}
            value={field.value}
            withSearch={withSearch}
          />
        );
      }}
    />
  );
};
